// extracted by mini-css-extract-plugin
module.exports = {"terms":"terms_terms___d2p2","term":"terms_term__K3Jq5"};